<div class="ng-bootstrap-card p-3">
  <div class="d-flex flex-row m-0">
    <div class="pe-3">
      <fa-icon [icon]="mfaService.getTypeIcon(device)"></fa-icon>
    </div>
    <div class="d-flex flex-column flex-grow-1 enabled-device-details">
      <h4>{{ device?.type }}</h4>
      <p>{{ device?.displayID }} @if (device?.deviceRole === 'PRIMARY') {
        <strong>({{ 'content.default' | translate }})</strong>
      }</p>
      <p>{{ mfaService.getDescriptionI18nKey(device) | translate }}</p>
      <span id="remove-device-description" class="d-none">{{ 'aria.remove-device-dialog' | translate }}</span>
      <div class="d-flex flex-row justify-content-end ms-0 me-0 mt-2 inline-gap-10" #modalContainer>
        @if (allowChangingPrimary && device?.deviceRole === 'SECONDARY') {
          <button class="tu-button tu-shadow secondary"
            (click)="confirmPrimary('remove-device-description', modalContainer)">
            {{ 'content.set-as-default' | translate }}
          </button>
        }
        @if (allowRemovingDevice) {
          <button class="tu-button tu-shadow primary" (click)="confirmRemove('remove-device-description', modalContainer)">{{ 'content.remove' | translate }}</button>
        }
      </div>
    </div>
  </div>
</div>
